import clsx from "clsx"
import {forwardRef} from "react"
import "./Radio.css"

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onSelect" | "value"> {
    label: string | undefined | null
    invalid?: boolean | undefined
    containerProps?: React.HTMLAttributes<HTMLSpanElement> | undefined
    selected?: boolean | undefined
    onSelect?: ((value: string) => void) | undefined
    value: string
}

const Radio: React.FC<RadioProps> = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
    const {className, selected, onSelect, containerProps, value, label, invalid, children, onClick, ...otherProps} =
        props

    const onClickHandler = (event: React.MouseEvent<HTMLInputElement>) => {
        if (onClick) onClick(event)
        if (onSelect) onSelect(value)
    }

    return (
        <span className={clsx("radio-container-eb96", className)} {...containerProps}>
            <span className={clsx("radio-eb96", selected ? "selected-eb96" : "", invalid ? "invalid-eb96" : "")}>
                <input
                    className="radio-input-eb96"
                    type="radio"
                    ref={ref}
                    aria-checked={selected}
                    onClick={onClickHandler}
                    value={value}
                    {...otherProps}
                />
                <div className="check-dot-eb96" />
            </span>
            {label && <span className="label-eb96">{label}</span>}
        </span>
    )
})

export default Radio
